import {
  ActionIcon,
  Badge,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  Loader,
  LoadingOverlay,
  Menu,
  MultiSelect,
  rem,
  Select,
  SelectProps,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedState, useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBrandBootstrap,
  IconCalendar,
  IconCaretDown,
  IconCheck,
  IconEdit,
  IconFileExport,
  IconFileUpload,
  IconPackageExport,
  IconSearch,
  IconStatusChange,
  IconTrolley,
  IconTruck,
  IconUser,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import {
  _timerDelayClick,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { AvatarUtils } from "../../../common/ColorByName/AvatarUtils";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { BASE_API_MDM } from "../../../config";
import { _localization } from "../../../config/location";
import {
  beige,
  green,
  navy_blue,
  sky_blue,
  teal,
} from "../../../const/variables";
import { TblDMExpense } from "../../../model/TblDMExpense";
import { getBranchSelectMdm } from "../../../service/getSelectApi";
import EditDataView from "./EditDataView";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import Avvvatars from "avvvatars-react";
import { useLocation } from "react-router-dom";

const DeliveryPayKT = () => {
  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblDMExpense[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  // const [keySearch, setKeySearch] = useState<string>("");
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  //select
  const [idCn, setIdCn] = useState<string[]>([]);
  const [dataVehicle] = useState<any[]>([
    { label: "Xe máy", value: "XE_MAY" },
    { label: "Ô tô", value: "O_TO" },
  ]);
  const [dataEmployeeSelect, setDataEmployeeSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [dataTblBranch, setDataTblBranch] = useState<any[]>([]);
  const [dataDeliveryWork, setDataDeliveryWork] = useState<ComboboxItem[]>([]);
  const dataTblDeliveryStatusSelect = [
    {
      value: "Nối chuyến",
      label: "Nối chuyến",
    },
    {
      value: "Nhập lại toàn bộ",
      label: "Nhập lại toàn bộ",
    },
    {
      value: "Nhập lại một phần",
      label: "Nhập lại một phần",
    },
    {
      value: "Đã phân công",
      label: "Đã phân công",
    },
    {
      value: "Lập đơn giao hàng",
      label: "Lập đơn giao hàng",
    },
    {
      value: "Đang giao hàng",
      label: "Đang giao hàng",
    },
    {
      value: "Đã đến nơi",
      label: "Đã đến nơi",
    },
    {
      value: "Đơn hàng giao chưa thành công do Khách hàng",
      label: "Đơn hàng giao chưa thành công do Khách hàng",
    },
    {
      value: "Đơn hàng giao chưa thành công do Hacom",
      label: "Đơn hàng giao chưa thành công do Hacom",
    },
    {
      value: "Hàng đã giao",
      label: "Hàng đã giao",
    },
    {
      value: "Tiếp nhận",
      label: "Tiếp nhận",
    },
    {
      value: "Hủy phân công",
      label: "Hủy phân công",
    },
    {
      value: "Hủy đơn",
      label: "Hủy đơn",
    },
    {
      value: "DA_PHAN_CONG",
      label: "Đã phân công",
    },
    {
      value: "DA_XU_LY",
      label: "Đã xủ lý",
    },
    {
      value: "HUY_PHAN_CONG",
      label: "Hủy phân công",
    },
    {
      value: "TRA_KHACH",
      label: "Trả khách",
    },
  ];
  //search
  const [search, setSearch] = useState<{
    startDate: string;
    endDate: string;
    branchCode: string[];
    sourceType: string[];
    status: string[];
    EmpIds: string[];
    DeliveryWorkNames: string[];
    VehicleCode: string;
  }>({
    startDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.startDate
        : new Date(
            new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              1,
            ).getTime() +
              7 * 60 * 60 * 1000,
          ).toISOString(),
    endDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.endDate
        : new Date(new Date().getTime() + 7 * 60 * 60 * 1000).toISOString(),
    branchCode: _searchJson && checkedPinSearch ? _searchJson?.branchCode : [],
    sourceType: _searchJson && checkedPinSearch ? _searchJson?.sourceType : [],
    status: _searchJson && checkedPinSearch ? _searchJson?.status : [],
    EmpIds: _searchJson && checkedPinSearch ? _searchJson?.EmpIds : [],
    DeliveryWorkNames:
      _searchJson && checkedPinSearch ? _searchJson?.DeliveryWorkNames : [],
    VehicleCode:
      _searchJson && checkedPinSearch ? _searchJson?.VehicleCode : "",
  });

  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300,
  );

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "branchName",
        header: "Tên chi nhánh",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            [{row.original.branchCode}] - {row.original.branchName}
          </Text>
        ),
      },
      {
        accessorKey: "createDate",
        header: "Ngày lập",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "assignmentDate",
        header: "Ngày phân công",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "soChungTuGoc",
        header: "Số chứng từ gốc",
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            radius="sm"
            variant="dot"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? "Không xác định" : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "sourceType",
        header: "Nguồn chứng từ",
        Cell: ({ row }) => (
          <Badge
            color={getColorSourceType(row.original.sourceType)}
            radius={"sm"}
          >
            {row.original.sourceType}
          </Badge>
        ),
      },
      {
        accessorKey: "code",
        header: "Số vận đơn",
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            radius="sm"
            variant="dot"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? "Không xác định" : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "transactionNumber",
        header: "Số giao dịch",
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            radius="sm"
            variant="dot"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? "Không xác định" : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "employee1",
        header: "Nhân viên giao hàng",
        Cell: ({ renderedCellValue }) => (
          <AvatarUtils
            value={renderedCellValue?.toString() ?? ""}
            sizeXS={true}
          />
        ),
      },
      {
        accessorKey: "employee2",
        header: "Nhân viên hỗ trợ",
        Cell: ({ renderedCellValue }) => (
          <AvatarUtils
            value={renderedCellValue?.toString() ?? ""}
            sizeXS={true}
          />
        ),
      },
      {
        accessorKey: "deliveryWorkName",
        header: "Công việc",
      },
      {
        accessorKey: "vehicleCode",
        header: "Phương tiện giao hàng",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="11.5px">
            {getValueById(String(renderedCellValue), dataVehicle, "label") ||
              renderedCellValue}
          </Text>
        ),
        size: 225,
      },
      {
        accessorKey: "deliveryWorkPoint",
        header: "Điểm",
        size: 125,
      },
      {
        accessorKey: "modifiedPoint",
        header: "Điểm đã sửa",
        size: 160,
      },
      {
        accessorKey: "toAddress",
        header: "Địa chỉ giao hàng",
        size: 500,
      },
      {
        accessorKey: "noteByEmp",
        header: "Ghi chú đơn hàng",
      },
      {
        accessorKey: "noteByDelivery",
        header: "Ghi chú giao hàng",
      },
      {
        accessorKey: "customerName",
        header: "Tên khách hàng",
      },
      {
        accessorKey: "telephoneNumber",
        header: "SĐT khách hàng",
      },
      {
        accessorKey: "distanceTotal",
        header: "Quãng đường (km)",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {Number(renderedCellValue) / 1000}
          </Text>
        ),
        size: 200,
      },
      {
        accessorKey: "modifiedDistance",
        header: "Quãng đường đã sửa (km)",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {Number(renderedCellValue) / 1000}
          </Text>
        ),
        size: 235,
      },
      {
        accessorKey: "receptionTime",
        header: "Ngày tiếp nhận",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "deliveryTime",
        header: "Ngày giao hàng",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "arrivalTime",
        header: "Ngày đến nơi",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "completionTime",
        header: "Ngày hoàn thành",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "transactionFinishDate",
        header: "Ngày xuất kho",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "processingDate",
        header: "Ngày KTKT",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "deliveryStatusName",
        header: "Trạng thái đơn giao hàng",
        Cell: ({ renderedCellValue }) => (
          <Text size="12.5px" fw={500}>
            {getValueById(
              renderedCellValue?.toString() ?? "",
              dataTblDeliveryStatusSelect,
              "label",
            )}
          </Text>
        ),
        size: 350,
      },
      {
        accessorKey: "tienGuiXe",
        header: "Tiền gửi xe",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {Number(renderedCellValue)?.toLocaleString()} VNĐ
          </Text>
        ),
      },
      {
        accessorKey: "debt",
        header: "Công nợ",
      },
      {
        accessorKey: "amountTotal",
        header: "Tổng tiền đơn hàng",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {Number(renderedCellValue)?.toLocaleString()} VNĐ
          </Text>
        ),
      },
      {
        accessorKey: "amountPaid",
        header: "Đã thanh toán",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {Number(renderedCellValue)?.toLocaleString()} VNĐ
          </Text>
        ),
      },
      {
        accessorKey: "attribute8",
        header: "Tổng phải thanh toán",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {Number(renderedCellValue)?.toLocaleString()} VNĐ
          </Text>
        ),
        size: 225,
      },
      {
        accessorKey: "paymentStatus",
        header: "Tình trạng thanh toán",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getDataPaymentStatus(renderedCellValue?.toString() ?? "")}
          </Text>
        ),
        size: 225,
      },
      {
        accessorKey: "payroll",
        header: "Tính lương",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue === "1" ? "Có" : "Không"}
          </Text>
        ),
      },
      {
        accessorKey: "modifiedPayroll",
        header: "Tính lương đã sửa",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {renderedCellValue ? "Có" : "Không"}
          </Text>
        ),
      },
      {
        accessorKey: "createByName",
        header: "Kinh doanh tạo đơn",
        Cell: ({ renderedCellValue }) => (
          <AvatarUtils
            value={renderedCellValue?.toString() ?? ""}
            sizeXS={true}
          />
        ),
        size: 200,
      },
      {
        accessorKey: "assignTime",
        header: "Thời gian phân công",
        size: 200,
      },
      {
        accessorKey: "contactTime",
        header: "Thời gian liên hệ",
      },
      {
        accessorKey: "transferTime",
        header: "Thời gian di chuyển",
        size: 200,
      },
      {
        accessorKey: "workTime",
        header: "Thời gian thực hiện công việc",
        size: 275,
      },
      {
        accessorKey: "settingTime",
        header: "Thời gian lắp cài",
      },
      {
        accessorKey: "payrollModifiedDate",
        header: "Ngày sửa điểm",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "payrollModifiedByName",
        header: "Người sửa điểm",
        size: 225,
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue !== null ? (
            <Flex align={"center"} gap={"md"}>
              <Avvvatars
                value={`${renderedCellValue?.toString()?.normalize("NFD")}`}
              />
              <Text fw={500}>
                {row.original.payrollModifiedByCode} - {renderedCellValue}
              </Text>
            </Flex>
          ) : (
            ""
          ),
      },
      {
        accessorKey: "noteByManager",
        header: "Ghi chú quản lý",
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 80,
        enableResizing: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => (
          <Flex justify={"center"}>
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="orange"
                onClick={async () => {
                  editItem(row.original);
                }}
              >
                <IconEdit size={18} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    [dataTblDeliveryStatusSelect, dataVehicle],
  );

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const handleChangeSearchValue = (value: string | string[], key: string) => {
    setSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  function getColorSourceType(value: string) {
    switch (value) {
      case "Đơn hàng":
        return beige.base;
      case "Điều chuyển":
        return sky_blue.light_alt;
      case "Khác":
        return navy_blue.base;
      case "Xuất bảo hành":
        return "#7b2eda";
      case "Xuất trả khách":
        return "#c91a52";
      case "Xử lí tại nhà":
        return "green";
    }
  }

  function getDataPaymentStatus(value: string) {
    switch (value) {
      case "CHUA_THANH_TOAN":
        return "Chưa thanh toán";
      case "KHONG_CAN_THANH_TOAN":
        return "Không cần thanh toán";
      case "THANH_TOAN_MOT_PHAN":
        return "Thanh toán một phần";
      case "DA_THANH_TOAN":
        return "Đã thanh toán";
    }
  }

  const optionColorSourceType: Record<
    | "Đơn hàng"
    | "Điều chuyển"
    | "Khác"
    | "Xuất bảo hành"
    | "Xuất trả khách"
    | "Xử lí tại nhà",
    string
  > = {
    "Đơn hàng": "#E2E2B6",
    "Điều chuyển": "#6EACDA",
    Khác: "#03346E",
    "Xuất bảo hành": "#7b2eda",
    "Xuất trả khách": "#C91A52",
    "Xử lí tại nhà": "green",
  };

  const renderSelectOptionSourceType: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorSourceType[
            option.label as
              | "Đơn hàng"
              | "Điều chuyển"
              | "Khác"
              | "Xuất bảo hành"
              | "Xuất trả khách"
              | "Xử lí tại nhà"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && (
        <IconCheck size={"14px"} style={{ marginInlineStart: "auto" }} />
      )}
    </Group>
  );

  function editItem(data: any) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chỉnh sửa tính lương kỹ thuật giao vận</Title>
        </>
      ),
      size: "auto",
      children: <EditDataView data={data} onClose={setDeleteViewStatus} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (search.startDate.length > 0) {
      url += `&StartDate=${search.startDate}`;
    }

    if (search.endDate.length > 0) {
      url += `&EndDate=${search.endDate}`;
    }

    if (search.branchCode.length > 0) {
      url += search.branchCode.map((item) => `&BranchCode=${item}`).join("");
    }

    if (search.sourceType.length > 0) {
      url += search.sourceType.map((item) => `&SourceType=${item}`).join("");
    }

    if (search.status.length > 0) {
      url += search.status.map((item) => `&Status=${item}`).join("");
    }

    if (search.EmpIds && search.EmpIds?.length > 0) {
      url += search.EmpIds?.map((item) => `&EmpIds=${item}`).join("");
    }

    if (search.DeliveryWorkNames && search?.DeliveryWorkNames?.length > 0) {
      search.DeliveryWorkNames.forEach((i) => {
        url += `&DeliveryWorkNames=${i}`;
      });
    }

    if (search.VehicleCode && search?.VehicleCode?.length > 0) {
      url += `&VehicleCode=${search.VehicleCode}`;
    }

    if (keySearch.length > 0) {
      url += `&KeySearch=${keySearch}`;
    }

    try {
      const response = await repositoryMdm.get(
        `/api/v1/VReportDelivery/get-list-delivery${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        }),
      );
    }
    startCountdown();
  };

  const handleExportData = async () => {
    open();
    try {
      let url = `/api/v1/VReportDelivery/export-bao-cao-ki-thuat-giao-hang?Skip=${
        pagination?.pageIndex * pagination?.pageSize
      }&Take=${pagination.pageSize}`;

      if (search.startDate.length > 0) {
        url += `&StartDate=${search.startDate}`;
      }

      if (search.endDate.length > 0) {
        url += `&EndDate=${search.endDate}`;
      }

      if (search.branchCode.length > 0) {
        url += search.branchCode.map((item) => `&BranchCode=${item}`).join("");
      }

      if (search.sourceType.length > 0) {
        url += search.sourceType.map((item) => `&SourceType=${item}`).join("");
      }

      if (search.status.length > 0) {
        url += search.status.map((item) => `&Status=${item}`).join("");
      }

      if (search.EmpIds && search.EmpIds?.length > 0) {
        url += search.EmpIds?.map((item) => `&EmpIds=${item}`).join("");
      }

      if (search.DeliveryWorkNames && search?.DeliveryWorkNames?.length > 0) {
        search.DeliveryWorkNames.forEach((i) => {
          url += `&DeliveryWorkNames=${i}`;
        });
      }

      if (search.VehicleCode && search?.VehicleCode?.length > 0) {
        url += `&VehicleCode=${search.VehicleCode}`;
      }

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      const _url = BASE_API_MDM + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        NotificationExtension.Success("Export Excel thành công !");
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename =
          "bao_cao_tinh_luong_ky_thuat_giao_hang" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const dataBranchSelect = async () => {
    const getData = await getBranchSelectMdm();
    setDataTblBranch(
      getData
        ?.filter(
          (item) =>
            item.att2 != null && item.text != null && item.value != "-1",
        )
        ?.map((item) => ({
          value: item.att2,
          label: `${item.att2} - ${item.text}`,
          id: item.value,
        })),
    );
  };

  const getDataEmployee = async () => {
    const listBranchId = idCn.map((item) => `&ListBranchId=${item}`).join("");
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblDmEmployee/get-list?Skip=0${listBranchId}&Take=200`,
    );

    if (res && res?.success) {
      setDataEmployeeSelect(
        res.data
          ?.filter(
            (item: any) =>
              item.id != null &&
              item.fullname != null &&
              item?.attribute1 === "2",
          )
          ?.map((item: any) => ({
            value: item.id?.toString(),
            label: `${item.code} - ${item.fullname}`,
          })),
      );
    }
  };

  const fetchDataDeliveryWord = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblDmDeliveryWork/get-all",
    );

    if (res && res.success) {
      const data = res.data
        .filter(
          (i: any) => i.name && i.department && i.department.includes("2"),
        )
        .map((i: any) => ({
          label: i.name,
          value: i.name,
        }));

      setDataDeliveryWork(data);
    }
  };

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    fetchData();
  }, [pagination?.pageSize, pagination?.pageIndex, deleteViewStatus]);

  useEffect(() => {
    const filteredIds = dataTblBranch
      .filter((item) => search.branchCode.includes(item.value))
      .map((item) => item.id);

    setIdCn(filteredIds);
  }, [search.branchCode]);

  useEffect(() => {
    if (idCn && idCn.length > 0) {
      getDataEmployee();
    }
  }, [idCn]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (165 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [height]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    enableRowNumbers: true,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef} style={{ width: "100%" }}>
        <Flex wrap={"wrap"} justify={"space-between"}>
          <_breadcrumb></_breadcrumb>
          <Menu shadow="md" width={200}>
            <Menu.Target>
              <Button
                rightSection={
                  <IconCaretDown style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Chức năng
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item
                leftSection={
                  <IconFileExport style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={() => handleExportData()}
              >
                Export Excel
              </Menu.Item>
              <Tooltip label={"Chức năng đang update"}>
                <Menu.Item
                  leftSection={
                    <IconFileUpload
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Import Excel
                </Menu.Item>
              </Tooltip>
            </Menu.Dropdown>
          </Menu>
        </Flex>
        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa"
              defaultValue={keySearch}
              leftSection={<IconSearch color="#15aabf" />}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              value={
                search.startDate && search.startDate.length > 0
                  ? new Date(search.startDate)
                  : null
              }
              maxDate={
                search.endDate && search.endDate?.length > 0
                  ? new Date(search.endDate)
                  : new Date()
              }
              locale="vi"
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "startDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              value={
                search.endDate && search.endDate.length > 0
                  ? new Date(search.endDate)
                  : null
              }
              minDate={
                search.startDate && search.startDate?.length > 0
                  ? new Date(search.startDate)
                  : undefined
              }
              locale="vi"
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "endDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Chi nhánh"
              searchable
              clearable
              data={dataTblBranch?.map((item) => ({
                label: item.label,
                value: item.value,
              }))}
              value={
                search?.branchCode && search?.branchCode?.length > 0
                  ? search?.branchCode
                  : []
              }
              onClick={() => {
                if (dataTblBranch.length === 0) {
                  dataBranchSelect();
                }
              }}
              leftSection={
                <IconBrandBootstrap size={20} style={{ color: teal.base }} />
              }
              onChange={(e) =>
                handleChangeSearchValue(e ? e : [], "branchCode")
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Nhập mã hoặc tên nhân viên"
              data={dataEmployeeSelect}
              searchable
              clearable
              leftSection={<IconUser color="#15aabf" />}
              value={search?.EmpIds ?? []}
              onChange={(value) =>
                handleChangeSearchValue(value ? value : [], "EmpIds")
              }
              nothingFoundMessage={
                search?.branchCode && search?.branchCode.length > 0
                  ? "Không tìm thấy dữ liệu !"
                  : "Hãy chọn chi nhánh trước !"
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Nguồn hàng"
              data={[
                { label: "Đơn hàng", value: "Đơn hàng" },
                { label: "Điều chuyển", value: "Điều chuyển" },
                { label: "Khác", value: "Khác" },
                { label: "Xuất bảo hành", value: "Xuất bảo hành" },
                { label: "Xuất trả khách", value: "Xuất trả khách" },
                { label: "Xử lí tại nhà", value: "Xử lí tại nhà" },
              ]}
              leftSection={<IconPackageExport color="#15aabf" />}
              value={
                search?.sourceType && search?.sourceType?.length > 0
                  ? search?.sourceType
                  : []
              }
              onChange={(e) =>
                handleChangeSearchValue(e ? e : [], "sourceType")
              }
              clearable
              renderOption={renderSelectOptionSourceType}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Trạng thái"
              clearable
              data={dataTblDeliveryStatusSelect}
              value={
                search?.status && search?.status?.length > 0
                  ? search?.status
                  : []
              }
              leftSection={<IconStatusChange color="#15aabf" />}
              onChange={(e) => {
                handleChangeSearchValue(e ? e : [], "status");
              }}
              comboboxProps={{ width: 400 }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Công việc"
              leftSection={<IconTrolley color="#15aabf" />}
              data={dataDeliveryWork}
              value={
                search?.DeliveryWorkNames &&
                search?.DeliveryWorkNames?.length > 0
                  ? search?.DeliveryWorkNames
                  : []
              }
              clearable
              nothingFoundMessage="Không có dữ liệu !"
              onClick={() => {
                if (dataDeliveryWork.length === 0) {
                  fetchDataDeliveryWord();
                }
              }}
              onChange={(e) => handleChangeSearchValue(e, "DeliveryWorkNames")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Phương tiện giao hàng"
              leftSection={<IconTruck color="#15aabf" />}
              data={dataVehicle}
              value={
                search?.VehicleCode && String(search?.VehicleCode).length > 0
                  ? search?.VehicleCode
                  : null
              }
              clearable
              onChange={(e) =>
                handleChangeSearchValue(e ? e : "", "VehicleCode")
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 1.5 }}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={() => {
                fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
  });

  return (
    <>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={15}> Đang xử lý....</Title>
            </Flex>
          ),
        }}
      />
      <MantineReactTable table={table} />
    </>
  );
};
export default DeliveryPayKT;
